export enum occurrenceType {
    StartEnd = "startEnd",
    AllDay = "allDay",
    StartEndConfigurable = 'startEndConfigurable',
    AllDayConfigurable = 'allDayConfigurable'
}

export enum eventReplyStatusEnum {
    AwaitingStatus = "awaitingStatus",
    NotAttending = "notAttending",
    Attending = "attending",
    PendingApproval = "pendingApproval",
    Processing = "processing",
}

export enum MaxCapType {
    attendees  = 1,
    time = 2
}

export interface eventLocation {
    name: string;
}

export interface occurrence {
    start: Date;
    end: Date;
    occurrenceType: occurrenceType;
    span?:string;
    firstDay?:boolean;
    daySpan:number;
}

export enum WorkflowType {
    SingleApprovalWorkflow= 'SingleApproval',
    noApprovalWorkflow='NoApproval'
}

export interface plannerEvent {
    id:number, 
    title: string;
    location: eventLocation;
    occurrence: occurrence;
    description:string;
    allowAttendeesResponseUpdates: boolean
    maximumCapacity?: number
    isCancelled?:boolean
    awaitingApprovalCount?: number,
    maximumCapacityType?: MaxCapType,
    currentAttendingCount?: number,
    currentTimeAllocated?:string,
    workflowType?: WorkflowType,
    eventWorkflowId?: number
    registrationStatus?: 'Open' | 'Closed'
}

export interface plannerEventCount {
    attendingCount:number;
    awaitingResponseCount: number;
    declinedCount: number;
    totalCount: number;
    replyRate:number;
}

export interface user {
    id: number;
    name: string;
    jobTitle: string;
    profilePicUrl: string;
    alias: string;
    displayName: string;
    department?: any;
    reply?: {
        endSelection: string;
        eventReplyType: string;
        repliedAt:string;
        startSelection:string;
        workflowResponseId? :number;
    },
    eventReplyStatus? : eventReplyStatusEnum;
}

export interface userSearch {
    users: user[];
    totalUserCount: number;
    previousSkip: number;
    nextSkip: number;
}

export interface group {
    id: number;
    groupName: string;
    totalUsersInGroup: number;
    alias: string;
}

export interface groupSearch {
    groups: group[];
    previousSkip: number;
    nextSkip: number;
}

export interface plannerEventCount {
    attendingCount:number;
    awaitingResponseCount: number;
    declinedCount: number;
    totalCount: number;
}

export interface ReportProcessorNotification {
    FileId: number,
    Filename: string,
    Path: string
} 